import React from 'react';
import { Box, Typography } from '@mui/material';

const SettingsInfo = ({ settings }) => (
  <Box sx={{ mt: 2 }}>
    <Typography variant="h6" color="green" mb={1} fontWeight="bold">
      Ready to stream
    </Typography>
    <ul>
      <li>WebCam Enabled: {settings.hasWebcam?.toString() || 'false'}</li>
      <li>Microphone Enabled: {settings.hasMicrophone?.toString() || 'false'}</li>
      <li>Microphone Active: {settings.isMicrophoneAlreadyCaptured?.toString() || 'false'}</li>
      <li>WebCam Active: {settings.isWebcamAlreadyCaptured?.toString() || 'false'}</li>
    </ul>
  </Box>
);

export default SettingsInfo;
